import { useEffect, useState } from "react";
import { Grid, KpiCard } from "../../../../components";
import { MonitorFaturamentoService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";
const monitorFaturamentoService = new MonitorFaturamentoService();

const defaultIndicadores = {
  faturamentoBruto: null,
  devolucao: null,
  desconto: null,
  faturamentoLiquido: null,
  quantidadeVendas: null,
  ticketMedio: null,
  cmv: null,
  lucro: null,
  margemContribuicao: null,
};

const defaultDocumentos = {
  nfeEmitidas: null,
  nfceEmitidas: null,
  nfseEmitidas: null,
};

const formatQuantidade = (v) => (v || 0).toLocaleString("pt-br");

function valorIndicador(indicador, formatar) {
  if (!indicador) return { value: formatar(0), variation: null };
  return {
    value: formatar(indicador.atual),
    variation: indicador.variacaoPercentual,
  };
}

function MonitorFatKpis({ filtrosBody }) {
  const [indicadores, setIndicadores] = useState(defaultIndicadores);
  const [documentos, setDocumentos] = useState(defaultDocumentos);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    buscarIndicadores();
    buscarDocumentos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscarIndicadores() {
    setLoading(true);
    const result = await monitorFaturamentoService.dashboardIndicadores(
      filtrosBody,
    );
    if (!result.isAxiosError) {
      setIndicadores(result.data || defaultIndicadores);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  async function buscarDocumentos() {
    setLoading(true);
    const result = await monitorFaturamentoService.dashboardDocumentosFiscais(
      filtrosBody,
    );
    if (!result.isAxiosError) {
      setDocumentos(result.data || defaultDocumentos);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const cards = [
    {
      title: "Faturamento Bruto",
      icon: "ph-currency-dollar",
      color: "#1976d2",
      ...valorIndicador(indicadores.faturamentoBruto, formatPrice),
    },
    {
      title: "Devolução",
      icon: "ph-arrow-u-down-left",
      color: "#d32f2f",
      invert: true,
      ...valorIndicador(indicadores.devolucao, formatPrice),
    },
    {
      title: "Desconto",
      icon: "ph-tag",
      color: "#ffa000",
      invert: true,
      ...valorIndicador(indicadores.desconto, formatPrice),
    },
    {
      title: "Faturamento Líquido",
      icon: "ph-currency-dollar",
      color: "#388e3c",
      ...valorIndicador(indicadores.faturamentoLiquido, formatPrice),
    },
    {
      title: "Quantidade de Vendas",
      icon: "ph-shopping-cart",
      color: "#7b1fa2",
      ...valorIndicador(indicadores.quantidadeVendas, formatQuantidade),
    },
    {
      title: "Ticket Médio",
      icon: "ph-ticket",
      color: "#0097a7",
      ...valorIndicador(indicadores.ticketMedio, formatPrice),
    },
    {
      title: "CMV",
      icon: "ph-package",
      color: "#f57c00",
      ...valorIndicador(indicadores.cmv, formatPrice),
    },
    {
      title: "Lucro",
      icon: "ph-chart-line-up",
      color: "#8e24aa",
      ...valorIndicador(indicadores.lucro, formatPrice),
    },
    {
      title: "Margem de Contribuição",
      icon: "ph-chart-pie-slice",
      color: "#6d4c41",
      ...valorIndicador(indicadores.margemContribuicao, formatPrice),
    },
    {
      title: "NF-e Emitidas",
      icon: "ph-receipt",
      color: "#455a64",
      ...valorIndicador(documentos.nfeEmitidas, formatPrice),
    },
    {
      title: "NFC-e Emitidas",
      icon: "ph-receipt",
      color: "#c2185b",
      ...valorIndicador(documentos.nfceEmitidas, formatPrice),
    },
    {
      title: "NFS-e Emitidas",
      icon: "ph-receipt",
      color: "#00796b",
      ...valorIndicador(documentos.nfseEmitidas, formatPrice),
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 1 }}>
      {cards.map((card) => (
        <Grid key={card.title} item xs={6} md={3}>
          <KpiCard
            title={card.title}
            value={card.value}
            subtitle={card.subtitle}
            icon={card.icon}
            color={card.color}
            variation={card.variation}
            invert={card.invert}
            loading={loading}
          />
        </Grid>
      ))}
    </Grid>
  );
}

export default MonitorFatKpis;
